/**
 * Dicionário central para todos os textos de tooltips da aplicação.
 * A estrutura é organizada por página ou contexto para facilitar a manutenção.
 */
export const tooltipTexts = {
    solicitacaoContratacao: {
        novaSolicitacao: "Selecione o nível de acesso/equipamento que a MOT necessita. Esta informação é opcional no momento do preenchimento da solicitação.",
        confirmarContratacao: "Selecione o nível de acesso/equipamento que a MOT necessita. Esta informação é necessária para seguir com a contratação.",
        // Adicione outras chaves para esta página aqui...
    }
};